<template>
<div>
  <h3>Primeros del Cole</h3>

  <h4 class="py-3">Destinatarios</h4>

  <p>RECORDATORIO: El uso del servicio de Primeros del Cole, al igual que cualquier otro servicio ofrecido por el AMPA,
  es exclusivo para los socios activos (es decir, que se hayan renovado en el curso actual). Cualquier uso del servicio,
  aun siendo puntual, implica la renovación automática y el pago de la cuota anual de socios.</p>

  <h4 class="py-3">Precio por día</h4>

  <p>Esta actividad sigue un modelo de precio por día de asistencia, permitiendo adaptarse al uso real del servicio
  de cada familia, considerando que es un servicio de primera necesidad.</p>

  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Concepto</th>
        <th class="text-center">Precio diario</th>
      </tr>
    </thead>
    <tbody>
      <tr><td>Entrada desde las 7:30</td><td class="text-right">{{ precios.horas['07:30'].toFixed(2) }}&nbsp;€</td></tr>
      <tr><td>Entrada desde las 8:00</td><td class="text-right">{{ precios.horas['08:00'].toFixed(2) }}&nbsp;€</td></tr>
      <tr><td>Entrada desde las 8:30</td><td class="text-right">{{ precios.horas['08:30'].toFixed(2) }}&nbsp;€</td></tr>
      <tr><td>Descuento por cada día de asistencia</td><td class="text-right">{{ (100 * precios.descuento.incrementoDiario).toFixed(2) }}%<template v-if="precios.descuento.diasSinDescuento > 1"><br />(a partir del día {{ precios.descuento.diasSinDescuento }})</template></td></tr>
      <tr><td>Desayuno (descuento no aplicable)</td><td class="text-right">{{ precios.desayuno.toFixed(2) }}&nbsp;€</td></tr>
    </tbody>
  </table>

  <p>Para calcular el precio mensual, se suma el precio diario de todos los días de uso del servicio (según la hora de entrada de
  cada día), y sobre esa cantidad se aplica un descuento en función del número total de días de asistencia en ese mes. Por último,
  se añade el coste de los desayunos disfrutados.</p>

  <h4 class="py-3">Calculadora de precios</h4>

  <div class="form-group row">
    <label class="col-4 col-md-2 col-form-label" for="calc-entrada-730">Días 7:30</label>
    <div class="col-4 col-md-2">
      <input id="calc-entrada-730" name="calc-entrada-730" type="text" v-model.number="calculadora.entrada730" class="form-control">
    </div>
  </div>

  <div class="form-group row">
    <label class="col-4 col-md-2 col-form-label" for="calc-entrada-800">Días 8:00</label>
    <div class="col-4 col-md-2">
      <input id="calc-entrada-800" name="calc-entrada-800" type="text" v-model.number="calculadora.entrada800" class="form-control">
    </div>
  </div>

  <div class="form-group row">
    <label class="col-4 col-md-2 col-form-label" for="calc-entrada-830">Días 8:30</label>
    <div class="col-4 col-md-2">
      <input id="calc-entrada-830" name="calc-entrada-830" type="text" v-model.number="calculadora.entrada830" class="form-control">
    </div>
  </div>

  <div class="form-group row">
    <label class="col-4 col-md-2 col-form-label" for="calc-desayunos">Desayunos</label>
    <div class="col-4 col-md-2">
      <input id="calc-desayunos" name="calc-desayunos" type="text" v-model.number="calculadora.desayunos" class="form-control">
    </div>
  </div>

  <div class="form-group row" v-if="! errorCalculadora">
    <label class="col-4 col-md-2 col-form-label" for="calc-total">Precio mensual</label>
    <div class="col-4 col-md-2">
      <input id="calc-total" name="calc-total" type="text" :value="calculos.precioTotal.toFixed(2)" class="form-control" readonly>
    </div>
  </div>

  <p v-if="errorCalculadora" class="text-danger">ERROR: {{ errorCalculadora }}</p>
  <ul v-else>
    <li>{{ calculadora.entrada730 }} días a las 7:30: {{ calculadora.entrada730 }} x {{ precios.horas['07:30'].toFixed(2) }} € = {{ calculos.precio730.toFixed(2) }} €</li>
    <li>{{ calculadora.entrada800 }} días a las 8:00: {{ calculadora.entrada800 }} x {{ precios.horas['08:00'].toFixed(2) }} € = {{ calculos.precio800.toFixed(2) }} €</li>
    <li>{{ calculadora.entrada830 }} días a las 8:30: {{ calculadora.entrada830 }} x {{ precios.horas['08:30'].toFixed(2) }} € = {{ calculos.precio830.toFixed(2) }} €</li>
    <li>Precio por asistencia: {{ calculos.precio730.toFixed(2) }} + {{ calculos.precio800.toFixed(2) }} + {{ calculos.precio830.toFixed(2) }} = {{ calculos.precioAsistencia.toFixed(2) }} €
    <li>Descuento por {{ calculos.totalDias }} días: {{ calculos.totalDias - precios.descuento.diasSinDescuento }} x {{ 100 * precios.descuento.incrementoDiario }}% = {{ (100 * calculos.descuento).toFixed(2) }}%</li>
    <li>Precio por asistencia tras descontar {{ (100 * calculos.descuento).toFixed(2) }}% = {{ calculos.precioAsistenciaDescontado.toFixed(2) }} €</li>
    <li>Precio por desayunos: {{ calculadora.desayunos }} x {{ precios.desayuno.toFixed(2) }} € = {{ calculos.precioDesayunos.toFixed(2) }} €</li>
    <li>Precio total del mes: {{ calculos.precioAsistenciaDescontado.toFixed(2) }} € + {{ calculos.precioDesayunos.toFixed(2) }} € = {{ calculos.precioTotal.toFixed(2) }} €</li>
  </ul>

  <h4 class="pt-3 pb-2">Precio mensual asistiendo todos los días del mes</h4>

  <p>A modo de referencia, se muestra el precio mensual equivalente a asistir todos los días de cada mes del curso 2022/2023:</p>

  <table class="table table-bordered table-condensed">
    <thead>
      <tr>
        <th class="text-center align-middle">Mes</th>
        <th class="text-center align-middle d-none d-md-table-cell">Días</th>
        <th class="text-center">7:30 (con)</th>
        <th class="text-center">8:00 (con)</th>
        <th class="text-center">7:30 (sin)</th>
        <th class="text-center">8:00 (sin)</th>
        <th class="text-center">8:30 (sin)</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(_, periodo) in diasPeriodo" :key="periodo">
        <td class="text-right">{{ periodo | mostrarMes }}</td>
        <td class="text-right d-none d-md-table-cell">{{ diasPeriodo[periodo] }}</td>
        <td class="text-right">{{ precioMes(periodo, '07:30', true).toFixed(2) }}<span class="d-none d-md-inline">&nbsp;€</span></td>
        <td class="text-right">{{ precioMes(periodo, '08:00', true).toFixed(2) }}<span class="d-none d-md-inline">&nbsp;€</span></td>
        <td class="text-right">{{ precioMes(periodo, '07:30', false).toFixed(2) }}<span class="d-none d-md-inline">&nbsp;€</span></td>
        <td class="text-right">{{ precioMes(periodo, '08:00', false).toFixed(2) }}<span class="d-none d-md-inline">&nbsp;€</span></td>
        <td class="text-right">{{ precioMes(periodo, '08:30', false).toFixed(2) }}<span class="d-none d-md-inline">&nbsp;€</span></td>
      </tr>
    </tbody>
  </table>

</div>
</template>

<script>

export default {
	name: 'SociosInfoPrimeros',
	data () {
		return {
			precios: null,
			diasPeriodo: null,
			calculadora: null,
			errorCalculadora: null,
		}
	},
	created () {
		this.precios = {
			horas: {
				'07:30': 3.60,
				'08:00': 2.85,
				'08:30': 2.10,
			},
			descuento: {
				incrementoDiario: 0.0225,
				diasSinDescuento: 1,
			},
			desayuno: 1.70,
		};
		this.diasPeriodo = {
			202209: 18,
			202210: 19,
			202211: 20,
			202212: 12,
			202301: 17,
			202302: 18,
			202303: 21,
			202304: 14,
			202305: 21,
			202306: 16,
		};
		this.calculadora = {
			entrada730: 0,
			entrada800: 0,
			entrada830: 0,
			desayunos: 0,
		};
		this.actualizarCalculadora();
	},
	watch: {
		calculadora: {
			handler() {
				this.actualizarCalculadora();
			},
			deep: true
		}
	},
	methods: {
        descuentoDias(dias) {
			return Math.max(0, dias - this.precios.descuento.diasSinDescuento) * this.precios.descuento.incrementoDiario;
		},
        precioDias(dias, hora, desayuno) {
			let precio = dias * this.precios.horas[hora];
			const descuento = this.descuentoDias(dias);
			precio = precio * (1 - descuento)
			if (desayuno) {
				precio += dias * this.precios.desayuno;
			}
			return precio;
		},
        precioMes(periodo, hora, desayuno) {
			const dias = this.diasPeriodo[periodo];
			return this.precioDias(dias, hora, desayuno);
		},
		actualizarCalculadora() {
			const calculos = {};
			calculos.totalDias = this.calculadora.entrada730 + this.calculadora.entrada800 + this.calculadora.entrada830;
			if (this.calculadora.entrada730 > 23 || this.calculadora.entrada800 > 23 || this.calculadora.entrada830 > 23 || calculos.totalDias > 23) {
				this.errorCalculadora = 'No puede haber más de 23 días en un mes';
				this.calculos = null;
				return;
			}
			if (this.calculadora.desayunos > (this.calculadora.entrada730 + this.calculadora.entrada800)) {
				this.errorCalculadora = 'No hay suficientes días para el número de desayunos indicado';
				this.calculos = null;
				return;
			}
			calculos.precio730 = this.calculadora.entrada730 * this.precios.horas['07:30'];
			calculos.precio800 = this.calculadora.entrada800 * this.precios.horas['08:00'];
			calculos.precio830 = this.calculadora.entrada830 * this.precios.horas['08:30'];
			calculos.precioAsistencia = calculos.precio730 + calculos.precio800 + calculos.precio830;
			calculos.descuento = Math.max(0, calculos.totalDias - this.precios.descuento.diasSinDescuento) * this.precios.descuento.incrementoDiario;
			calculos.precioAsistenciaDescontado = calculos.precioAsistencia * (1 - calculos.descuento);
			calculos.precioDesayunos = this.precios.desayuno * this.calculadora.desayunos;
			calculos.precioTotal = calculos.precioAsistenciaDescontado + calculos.precioDesayunos
			this.errorCalculadora = null;
			this.calculos = calculos;
		}
	},
	filters: {
		// TODO: repetido
		mostrarMes: function(mes) {
			return mes.substring(4, 6) + '/' + mes.substring(0, 4)
		},
	}
}
</script>
